import { JobBrowsingApi } from '../api/jobBrowsing.api';
import { JobBrowseResponse } from '../types';
import { Job } from '../../../company/JobManagement/model/JobModel';

export const useJobBrowsingController = () => {

  const browseJobs = async (params: {
    limit: number;
    offset: number;
    query?: string;
    location?: string;
    job_type?: string;
    work_mode?: string;
    salary_min?: string;
  }): Promise<JobBrowseResponse> => {
    try {
      const data = await JobBrowsingApi.browse(params);

      // Load applied jobs from localStorage
      const appliedJobs = JSON.parse(localStorage.getItem('applied_jobs') || '[]');

      // IMPORTANT: The browse endpoint doesn't return has_applied field
      // We need to check localStorage for each job
      const jobs: Job[] = data.jobs.map((job: any) => {
        // Check if this job ID is in localStorage
        const hasApplied = appliedJobs.includes(job.id);
        
        return {
          ...job,
          has_applied: hasApplied, 
          match_score: job.match_score ?? 0
        };
      });

      return {
        jobs,
        total: data.total,
        has_more: data.has_more
      };
    } catch (error) {
      console.error('Browse jobs error:', error);
      throw error;
    }
  };

  const getJobDetails = async (jobId: string): Promise<Job> => {
    try {
      const job: any = await JobBrowsingApi.getDetails(jobId);
      
      // Also check localStorage as backup
      const appliedJobs = JSON.parse(localStorage.getItem('applied_jobs') || '[]');
      const hasAppliedFromStorage = appliedJobs.includes(jobId);
      
      // Use API value if available, otherwise localStorage
      const hasApplied = job.has_applied ?? hasAppliedFromStorage;
      
      console.log('🔍 Job details has_applied:', {
        fromAPI: job.has_applied,
        fromStorage: hasAppliedFromStorage,
        final: hasApplied
      });

      return {
        ...job,
        has_applied: hasApplied,
        match_score: job.match_score ?? 0
      } as Job;
    } catch (error) {
      console.error('Get job details error:', error);
      throw error;
    }
  };

  const applyToJob = async (jobId: string, coverLetter?: string): Promise<any> => {
  try {
    
    // Save to localStorage first (optimistic update)
    const appliedJobs = JSON.parse(localStorage.getItem('applied_jobs') || '[]');
    if (!appliedJobs.includes(jobId)) {
      appliedJobs.push(jobId);
      localStorage.setItem('applied_jobs', JSON.stringify(appliedJobs));
    }
    
    const result = await JobBrowsingApi.apply(jobId, coverLetter);
    
    const responseMessage = result?.message || result?.msg || '';
    if (responseMessage.toLowerCase().includes('already applied')) {
    }
    
    return result;
  } catch (error: any) {
    console.error('❌ Apply to job API error:', error);
    
    throw error;
  }
};

  return {
    browseJobs,
    getJobDetails,
    applyToJob
  };
};